export default "/images/img_7.png?586bfa32aecb7d2afb12786ee696ea26";